







import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import ElementMixin from './ElementMixin'

export default mixins(ElementMixin).extend({
  computed: {
    editedValue: {
      get(): number {
        return this.value[this.variable] as number
      },
      set(value: number) {
        if (value == undefined || value.toString().trim() === '') {
          this.$set(this.value, this.variable, null)
        } else {
          this.$set(this.value, this.variable, value)
        }
      },
    },
  },
  props: {
    min: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: [String, Object],
    },
    defaultValue: {
      type: Number,
      default: undefined,
    },
  },
  methods: {
    tieToBounds() {
      if (this.min && this.max && this.max < this.min) {
        throw new Error('max must be less than min, if given')
      }
      this.$nextTick(() => {
        // console.debug(this.variable, this.min, this.max, this.editedValue)
        if (typeof this.min === 'number' && this.editedValue < this.min) {
          this.editedValue = this.min
          console.log('adjust', this.variable, this.min, this.max, this.editedValue)
        }
        if (typeof this.max === 'number' && this.editedValue > this.max) {
          this.editedValue = this.max
          console.log('adjust', this.variable, this.min, this.max, this.editedValue)
        }
      })
    },
  },
})
